import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServiceCard } from '../components/ServiceCard';
import { StatsSection } from '../components/StatsSection';
import { CTASection } from '../components/CTASection';
import { Flame, ThermometerSun, Snowflake, Wind, Wrench, Factory } from 'lucide-react';
export function Home() {
  const services = [{
    title: 'Boiler Hire',
    description: 'Temporary packaged boilers available to hire on Gas, Gasoil and sustainable fuel options. Full turnkey solutions.',
    icon: Flame,
    path: '/boiler-hire'
  }, {
    title: 'Heater Hire',
    description: 'Electric, indirect fired and direct fired heaters for commercial and industrial applications.',
    icon: ThermometerSun,
    path: '/heater-hire'
  }, {
    title: 'Chiller Hire',
    description: 'High performance process and comfort cooling chillers available for immediate nationwide dispatch.',
    icon: Snowflake,
    path: '/chiller-hire'
  }, {
    title: 'Cooling Hire',
    description: 'Portable air conditioning units, evaporative coolers and cooling fans for all environments.',
    icon: Wind,
    path: '/cooling-hire'
  }, {
    title: 'Ancillaries',
    description: 'Hoses, heat exchangers, fuel tanks, and generators to support your temporary HVAC installation.',
    icon: Wrench,
    path: '/ancillaries'
  }, {
    title: 'Industry Sectors',
    description: 'Specialized solutions for Healthcare, Education, Facilities Management, Construction, and Events.',
    icon: Factory,
    path: '/services'
  }];
  return <main className="flex-grow" data-id="element-475">
      <HeroSection data-id="element-476" />

      {/* Services Section */}
      <section className="py-24 bg-white relative" data-id="element-477">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-478">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-479">
            <h2 className="text-brand-green font-bold tracking-wider uppercase text-sm mb-2" data-id="element-480">
              Our Services
            </h2>
            <h3 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark mb-6" data-id="element-481">
              Comprehensive Heating & Cooling Solutions
            </h3>
            <p className="text-gray-600 text-lg" data-id="element-482">
              We provide a modern fleet of highly efficient temporary HVAC
              equipment, supported by our experienced engineering team.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-483">
            {services.map((service, index) => <ServiceCard key={index} title={service.title} description={service.description} icon={service.icon} delay={index * 0.1} path={service.path} data-id="element-484" />)}
          </div>
        </div>
      </section>

      <StatsSection data-id="element-485" />

      <CTASection data-id="element-486" />
    </main>;
}